import { render, staticRenderFns } from "./UsersDashboards.vue?vue&type=template&id=46ec9b8d&scoped=true"
import script from "./UsersDashboards.vue?vue&type=script&lang=js"
export * from "./UsersDashboards.vue?vue&type=script&lang=js"
import style1 from "./UsersDashboards.vue?vue&type=style&index=1&id=46ec9b8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec9b8d",
  null
  
)

export default component.exports